"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /**
         * Framework base class for LightBox form controls
         * @internal
         */
        var LightBox = /** @class */ (function (_super) {
            __extends(LightBox, _super);
            function LightBox(data, element, parent, role) {
                var _this = this;
                var arrangeMethod = data.ArrangeMethod || $dyn.layout.ArrangeMethod.horizontalLeft;
                _this = _super.call(this, data, element, parent, role) || this;
                // Forms have a default of vertical when Lightboxes want a default of horizontal left.
                $dyn.setValue(_this, "ArrangeMethod", arrangeMethod);
                return _this;
            }
            return LightBox;
        }($dyn.controls.Dialog));
        controls.LightBox = LightBox;
        LightBox.prototype.IsLightBox = true;
        LightBox.prototype.Caption = $dyn.label("LightBoxNotificationAria");
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=LightBox.js.map
